import { Box, Button } from "@mui/material";
import { memo } from 'react';
import { theme } from "theme";

export interface IActionsButtonsProps {
    index: number,
    onClick: (event: React.MouseEvent<HTMLButtonElement>, item: any) => void;
    item: any;
    isValidButton: (item: any) => boolean;
}
const Ellipsis = (props: IActionsButtonsProps) => {
    return (
        <>
            {!props.isValidButton(props.item) ?
                <Box sx={{ minWidth: 'auto', width: '10px', height: '27px' }}></Box>
                :
                <Button onClick={(e: React.MouseEvent<HTMLButtonElement>) => props.onClick(e, props.item)} sx={{ minWidth: 'auto', width: '10px' }}>
                    <i id={`ellipsis-button-${props.index}`} style={{ width: '10px', color: theme.palette.common.black, fontSize: '15px' }} className="fa-solid fa-ellipsis-vertical"></i>
                </Button>
            }
        </>
    );
};
export default memo(Ellipsis);
